import { TooltipDesktop, Button, IconHeartOn16, IconHeartOff16 } from '@cian/ui-kit';
import { FC, MouseEvent } from 'react';

interface IFavoritesButtonProps {
  isFavorite: boolean;
  onClick: (event: MouseEvent<HTMLButtonElement>) => void;
}

export const FavoritesButton: FC<IFavoritesButtonProps> = ({ isFavorite, onClick }) => {
  return (
    <TooltipDesktop theme="black" placement="left" title={isFavorite ? 'В избранном' : 'Добавить в избранное'}>
      <Button
        data-name="FavoritesControl"
        size="XS"
        theme="stroke_secondary"
        onClick={onClick}
        beforeIcon={isFavorite ? <IconHeartOn16 color="error_100" /> : <IconHeartOff16 />}
      />
    </TooltipDesktop>
  );
};
